import { Injectable } from '@angular/core';

import { ZtHistoryTableItem } from 'src/app/components/zt-history-table/zt-history-table.model';
import { LanguageMap, VoicesMap } from 'src/app/core/models/execution.model';
import { ZtButtonType } from 'src/app/shared/components/atoms/zt-button/zt-button.model';
import { ZtIcon } from 'src/app/shared/components/atoms/zt-icon/zt-icon.model';

@Injectable()
export class ExecutionHistoryMapper {
    public map(
        executionHistory: any[],
        actionsMap: Map<string, Function>
    ): ZtHistoryTableItem[] {
        return executionHistory.map((data) => {
            return {
                id: data.id,
                data: {
                    id: data.id,
                    filePath: data.audio_file,
                },
                sample: {
                    filePath: data.audio_file,
                    action: actionsMap.get('sample'),
                    showControls: false,
                    playAudio: false,
                },
                actions: [
                    {
                        btnConfig: {
                            icon: ZtIcon.DOWNLOAD,
                            name: 'download',
                        },
                        btnType: ZtButtonType.PRIMARY,
                        name: 'download',
                        action: actionsMap.get('download'),
                    },
                    {
                        btnConfig: {
                            icon: ZtIcon.DELETE,
                            name: 'delete',
                        },
                        btnType: ZtButtonType.SECONDARY,
                        name: 'delete',
                        action: actionsMap.get('delete'),
                    },
                ],
                language: LanguageMap.get(data.language),
                pace: data.pace,
                pitch: data.pitch,
                requestedAt: new Date(data.requested_at),
                text: {
                    value: data.text,
                    isConcated: true,
                },
                voice: VoicesMap.get(data.voice),
            } as ZtHistoryTableItem;
        });
    }
}
